module.exports = __webpack_public_path__ + "img/girls.036ac06f.jpg";